import React from 'react';
import './Header.css';
import logo from '../../assets/images/logo.png';

export default function Header({ title, onLogout, onCreatePost, showBackButton = false, onBackClick }) {
  return (
    <header className="admin-header">
      <div className="header-brand">
        <img 
          src={logo}
          alt="Bahrul Ulum Islamic Center Logo"
          className="header-logo"
        />
        <div className="header-title-container">
          <h1 className="header-title">{title}</h1>
          <span className="header-subtitle">Bahrul Ulum Islamic Center</span>
        </div>
      </div>
      
      <div className="header-actions">
        {showBackButton ? (
          <button 
            onClick={onBackClick}
            className="btn-back"
          >
            <i className="fas fa-arrow-left"></i>
            <span>Kembali ke Dasbor</span>
          </button>
        ) : (
          onCreatePost && (
            <button 
              onClick={onCreatePost}
              className="btn-create"
            >
              <i className="fas fa-plus-circle"></i>
              <span>Buat Postingan</span>
            </button>
          )
        )}
        
        <div className="header-controls">
          {/* <button className="notification-btn">
            <i className="fas fa-bell"></i>
            <span className="notification-badge">3</span>
          </button> */}
          
          <div className="user-profile">
            <div className="user-avatar">
              <span>A</span>
            </div>
            <div className="user-info">
              <span className="user-name">Admin</span>
              <button
                onClick={onLogout}
                className="btn-logout"
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Keluar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
